import { render, staticRenderFns } from "./CheckboxText.vue?vue&type=template&id=111cd940&scoped=true"
import script from "./CheckboxText.vue?vue&type=script&lang=js"
export * from "./CheckboxText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111cd940",
  null
  
)

export default component.exports